const whiteAlpha = (opacity) => `rgba(255,255,255,${opacity})`;
const blackAlpha = (opacity) => `rgba(0,0,0,${opacity})`;

export {
  whiteAlpha,
  blackAlpha
};